import { Inject, Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { LenderLeadSession, LenderLeadSessionInjectionToken } from '../misc';

@Injectable()
export class CurrentLeCompanyService {
  constructor(@Inject(LenderLeadSessionInjectionToken) private session: LenderLeadSession) {}

  companyName$ = this.session.isFinishedLoading$.pipe(
    filter((state) => state === 'ready'),
    map(() => this.session.lenderLegalEntityDetails?.company)
  );
  isCiti$ = this.companyName$.pipe(map((company) => company === 'CITI'));
  isCompanyMs$ = this.companyName$.pipe(map((company) => company === 'MS'));
}
